import { MODIFY_LOCALE_LANGUAGE } from '../constants';

export function modify_local_language(payload) {
  const { language } = payload;
  return function (dispatch) {
    dispatch({
      type: MODIFY_LOCALE_LANGUAGE,
      locale_language: payload
    });
    localStorage.setItem('language', language);
  };
}
